<template>
  <div>
    <section class="p-box">
      <div class="p-box__body">
        <div class="c-grid">
          <div class="c-grid__items">
            <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
              <section class="p-box">
                <header class="p-box__header">
                  <h3 class="p-box__title">{{ $t('models.keyword.analysis.settings.keyword.setting') }}</h3>
                </header>
                <div class="p-box__body">
                  <Loading v-show="loading" />
                  <template v-if="!loading">
                    <Info>
                      {{ $t('models.keyword.analysis.settings.keyword.info') }}<br>
                      {{ $t('models.keyword.analysis.settings.keyword.notes') }}
                    </Info>
                    <div class="p-table">
                      <div class="p-table__content">
                        <table>
                          <thead>
                            <tr>
                              <th><span>{{ $t('models.keyword.analysis.settings.keyword.rule') }}</span></th>
                              <th><span>{{ $t('models.keyword.analysis.settings.keyword.created_at') }}</span></th>
                              <th />
                            </tr>
                            <tr class="p-table__content__space"><td colspan="5" /></tr>
                          </thead>
                          <tbody v-if="keywords && keywords.length != 0 ">
                            <tr v-for="keyword in keywords" :key="keyword.id">
                              <td>{{ keyword.attributes.rule }}</td>
                              <td>{{ dateFormat(keyword.attributes.created_at) }}</td>
                              <td>
                                <a class="p-table__content__delete" @click="onClickDeleteKeyword(keyword.id)">
                                  <img :src="iconCrossPath" alt="">
                                  {{ $t('pages.companies.analysis.keywords.delete') }}
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="c-button c-button--right">
                      <router-link :to="{ name: 'CompaniesReviewSettingKeywordNew', params: { company_uuid: currentCompanyUuid } }" class="c-button__item c-button__item--primary">{{ $t('labels.add', { value: $t('models.keyword.analysis.settings.keyword.rule') }) }}</router-link>
                    </div>
                  </template>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="p-box">
      <div class="p-box__body">
        <div class="c-grid">
          <div class="c-grid__items">
            <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
              <section class="p-box">
                <header class="p-box__header">
                  <h3 class="p-box__title">{{ $t('models.keyword.analysis.settings.ignore.setting') }}</h3>
                </header>
                <div class="p-box__body">
                  <Loading v-show="loading" />
                  <template v-if="!loading">
                    <Info>{{ $t('models.keyword.analysis.settings.ignore.info') }}</Info>
                    <div class="p-table">
                      <div class="p-table__content">
                        <table>
                          <thead>
                            <tr>
                              <th><span>{{ $t('models.keyword.analysis.settings.ignore.rule') }}</span></th>
                              <th><span>{{ $t('models.keyword.analysis.settings.ignore.created_at') }}</span></th>
                              <th />
                            </tr>
                            <tr class="p-table__content__space"><td colspan="5" /></tr>
                          </thead>
                          <tbody v-if="ignores && ignores.length != 0 ">
                            <tr v-for="ignore in ignores" :key="ignore.id">
                              <td>{{ ignore.attributes.rule }}</td>
                              <td>{{ dateFormat(ignore.attributes.created_at) }}</td>
                              <td>
                                <a class="p-table__content__delete" @click="onClickDeleteIgnore(ignore.id)">
                                  <img :src="iconCrossPath" alt="">
                                  {{ $t('pages.companies.analysis.keywords.delete') }}
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="c-button c-button--right">
                      <router-link :to="{ name: 'CompaniesReviewSettingIgnoreNew', params: { company_uuid: currentCompanyUuid } }" class="c-button__item c-button__item--primary">{{ $t('labels.add', { value: $t('models.keyword.analysis.settings.ignore.rule') }) }}</router-link>
                    </div>
                  </template>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Loading from '../../../components/Loading'
import Info from '../../../components/Info'
import moment from 'moment'
import { i18n } from '../../../plugins/i18n'
import iconCrossPath from '../../../../../images/common/icon_cross.svg'

export default {
  name: 'CompaniesManagementKeywords',
  components: {
    Loading,
    Info,
  },
  data() {
    return {
      iconCrossPath,
    }
  },
  computed: {
    ...mapState({
      keywords: state => state.companiesAnalysisSettingsKeywords.data,
      ignores: state => state.companiesAnalysisSettingsIgnores.data,
      loading: state => state.companiesAnalysisSettingsKeywords.loading || state.companiesAnalysisSettingsIgnores.loading,
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
  },
  created() {
    this.readKeywords(this.currentCompanyUuid)
    this.readIgnores(this.currentCompanyUuid)
  },
  methods: {
    ...mapActions({
      readKeywords: 'companiesAnalysisSettingsKeywords/readKeywords',
      deleteKeyword: 'companiesAnalysisSettingsKeywords/deleteKeyword',
      readIgnores: 'companiesAnalysisSettingsIgnores/readIgnores',
      deleteIgnore: 'companiesAnalysisSettingsIgnores/deleteIgnore',
    }),
    onClickDeleteKeyword(keyword_id) {
      if (confirm(this.$t('messages.confirmToDelete'))) {
        this.deleteKeyword({ company_uuid: this.currentCompanyUuid, keyword_id: keyword_id })
      }
    },
    onClickDeleteIgnore(ignore_id) {
      if (confirm(this.$t('messages.confirmToDelete'))) {
        this.deleteIgnore({ company_uuid: this.currentCompanyUuid, ignore_id: ignore_id })
      }
    },
    dateFormat(date) {
      return date ? moment(date).format(i18n.t('format.datetime.default')) : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.p-table__content {
  &__delete {
    display: flex;
    margin-top: 5px;
    cursor: pointer;
    text-decoration: none;
    img {
      margin-right: 10px;
    }
  }
}
</style>
